var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalfunctionsPeltonmiv(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 918 612",
    width: 918,
    height: 612,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n      .malfunction {\n        cursor: pointer;\n      }\n      .group {\n        cursor: pointer;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M679.597 306.002H325.097C324.463 305.994 323.857 305.738 323.409 305.29C322.96 304.842 322.705 304.236 322.697 303.602V303.602V281.102C322.705 280.467 322.96 279.862 323.409 279.413C323.857 278.965 324.463 278.709 325.097 278.702H454.097C454.731 278.694 455.337 278.438 455.786 277.99C456.234 277.542 456.489 276.936 456.497 276.302V266.902C456.489 266.267 456.234 265.662 455.786 265.213C455.337 264.765 454.731 264.509 454.097 264.502H287.597C286.963 264.494 286.357 264.238 285.909 263.79C285.46 263.342 285.205 262.736 285.197 262.102V254.602C285.205 253.967 285.46 253.362 285.909 252.913C286.357 252.465 286.963 252.209 287.597 252.202H353.297C353.931 252.194 354.537 251.938 354.986 251.49C355.434 251.042 355.689 250.436 355.697 249.802V249.802V211.902C355.689 211.267 355.434 210.662 354.986 210.213C354.537 209.765 353.931 209.509 353.297 209.502H308.797C308.163 209.494 307.557 209.238 307.109 208.79C306.66 208.342 306.405 207.736 306.397 207.102V207.102V172.102C306.389 171.467 306.134 170.862 305.686 170.413C305.237 169.965 304.631 169.709 303.997 169.702H276.197C275.881 169.706 275.567 169.646 275.274 169.527C274.981 169.408 274.715 169.231 274.491 169.008C274.267 168.784 274.091 168.518 273.972 168.225C273.852 167.932 273.793 167.618 273.797 167.302V167.302V145.802C273.793 145.485 273.852 145.171 273.972 144.878C274.091 144.585 274.267 144.319 274.491 144.096C274.715 143.872 274.981 143.695 275.274 143.576C275.567 143.457 275.881 143.398 276.197 143.402H323.297C323.931 143.394 324.537 143.138 324.986 142.69C325.434 142.242 325.689 141.636 325.697 141.002V136.502C325.705 135.867 325.96 135.262 326.409 134.813C326.857 134.365 327.463 134.109 328.097 134.102H369.797C370.431 134.109 371.037 134.365 371.486 134.813C371.934 135.262 372.189 135.867 372.197 136.502V136.502V139.002C372.189 139.636 371.934 140.242 371.486 140.69C371.037 141.138 370.431 141.394 369.797 141.402H363.997C363.681 141.398 363.367 141.457 363.074 141.576C362.781 141.695 362.515 141.872 362.291 142.096C362.067 142.319 361.891 142.585 361.772 142.878C361.652 143.171 361.593 143.485 361.597 143.802V143.802V145.702C361.605 146.336 361.86 146.942 362.309 147.39C362.757 147.838 363.363 148.094 363.997 148.102H369.797C370.431 148.109 371.037 148.365 371.486 148.813C371.934 149.262 372.189 149.867 372.197 150.502V153.002C372.189 153.636 371.934 154.242 371.486 154.69C371.037 155.138 370.431 155.394 369.797 155.402H335.397C335.081 155.398 334.767 155.457 334.474 155.576C334.181 155.695 333.915 155.872 333.691 156.096C333.467 156.319 333.291 156.585 333.172 156.878C333.052 157.171 332.993 157.485 332.997 157.802V157.802V167.302C332.993 167.618 333.052 167.932 333.172 168.225C333.291 168.518 333.467 168.784 333.691 169.008C333.915 169.231 334.181 169.408 334.474 169.527C334.767 169.646 335.081 169.706 335.397 169.702H466.197C466.513 169.706 466.827 169.646 467.12 169.527C467.413 169.408 467.679 169.231 467.903 169.008C468.127 168.784 468.303 168.518 468.423 168.225C468.542 167.932 468.601 167.618 468.597 167.302V167.302V150.502C468.605 149.867 468.86 149.262 469.309 148.813C469.757 148.365 470.363 148.109 470.997 148.102H471.797C472.431 148.109 473.037 148.365 473.486 148.813C473.934 149.262 474.189 149.867 474.197 150.502V173.602C474.189 174.236 473.934 174.842 473.486 175.29C473.037 175.738 472.431 175.994 471.797 176.002H420.797C420.163 176.009 419.557 176.265 419.109 176.713C418.66 177.162 418.405 177.767 418.397 178.402V313.902C418.405 314.536 418.66 315.142 419.109 315.59C419.557 316.038 420.163 316.294 420.797 316.302H679.597",
    fill: "none",
    stroke: "#DDDDDD",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.898 34C166.598 96.7 209.598 87.1 216.198 87.8",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M120.602 59.8984C143.202 97.1984 179.402 98.2984 190.702 95.8984",
    fill: "white",
    stroke: "#9C9C9C",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M567.103 176.395V188.313C567.088 189.05 566.788 189.754 566.266 190.276C565.744 190.797 565.041 191.097 564.303 191.113H257.803C257.065 191.097 256.362 190.797 255.84 190.276C255.318 189.754 255.018 189.05 255.003 188.313V113.395C255.01 112.717 254.771 112.059 254.329 111.544C253.888 111.029 253.274 110.692 252.603 110.595C245.603 109.495 225.003 104.995 216.203 87.6953",
    fill: "none",
    stroke: "#9C9C9C",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M239.05 183.133H165.25V186.933H239.05V183.133Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M241.753 186.953H162.453V203.253H241.753V186.953Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M223.302 183.205C225.897 183.205 228.002 181.1 228.002 178.505C228.002 175.909 225.897 173.805 223.302 173.805C220.706 173.805 218.602 175.909 218.602 178.505C218.602 181.1 220.706 183.205 223.302 183.205Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.2 183.205C213.796 183.205 215.9 181.1 215.9 178.505C215.9 175.909 213.796 173.805 211.2 173.805C208.604 173.805 206.5 175.909 206.5 178.505C206.5 181.1 208.604 183.205 211.2 183.205Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.2 183.205C195.796 183.205 197.9 181.1 197.9 178.505C197.9 175.909 195.796 173.805 193.2 173.805C190.604 173.805 188.5 175.909 188.5 178.505C188.5 181.1 190.604 183.205 193.2 183.205Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M181.098 183.205C183.694 183.205 185.798 181.1 185.798 178.505C185.798 175.909 183.694 173.805 181.098 173.805C178.503 173.805 176.398 175.909 176.398 178.505C176.398 181.1 178.503 183.205 181.098 183.205Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M223.083 115.383H180.883V173.783H223.083V115.383Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M234.089 165.078H223.289V169.178H234.089V165.078Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M223.102 161.8H234.102V133L223.102 116V161.8Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M181.003 165.102H170.203V169.202H181.003V165.102Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M181.003 161.8H170.203V133L181.003 116V161.8Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M223.083 111.055H180.883V115.355H223.083V111.055Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M216.394 86.9297H214.594V111.13H216.394V86.9297Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M215.398 104.2C216.194 104.2 216.957 103.884 217.52 103.321C218.082 102.759 218.398 101.996 218.398 101.2V92C218.398 91.2044 218.082 90.4413 217.52 89.8787C216.957 89.3161 216.194 89 215.398 89V89C214.603 89 213.84 89.3161 213.277 89.8787C212.715 90.4413 212.398 91.2044 212.398 92V101.2C212.419 101.989 212.741 102.741 213.3 103.299C213.858 103.857 214.609 104.18 215.398 104.2V104.2Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M189.722 95.4062H187.922V110.806H189.722V95.4062Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M188.797 107.098C189.593 107.098 190.356 106.782 190.918 106.22C191.481 105.657 191.797 104.894 191.797 104.098V100.398C191.797 99.6028 191.481 98.8397 190.918 98.2771C190.356 97.7145 189.593 97.3984 188.797 97.3984V97.3984C188.001 97.3984 187.238 97.7145 186.676 98.2771C186.113 98.8397 185.797 99.6028 185.797 100.398V104.098C185.797 104.894 186.113 105.657 186.676 106.22C187.238 106.782 188.001 107.098 188.797 107.098Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M366.603 162.503C376.489 162.503 384.503 154.489 384.503 144.603C384.503 134.717 376.489 126.703 366.603 126.703C356.717 126.703 348.703 134.717 348.703 144.603C348.703 154.489 356.717 162.503 366.603 162.503Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M825.388 436.5H296.798C286.94 436.49 277.342 433.337 269.398 427.5L179.498 360.9L178.898 360.5C186.698 349.7 200.598 340 225.398 337.9C248.798 335.9 262.198 328.4 269.898 319.5L270.298 319.8L314.698 351.5H825.689",
    fill: "#DDDDDD"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M825.388 436.5H296.798C286.94 436.49 277.342 433.337 269.398 427.5L179.498 360.9L178.898 360.5C186.698 349.7 200.598 340 225.398 337.9C248.798 335.9 262.198 328.4 269.898 319.5L270.298 319.8L314.698 351.5H825.689",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M615.844 327.602H760.991C761.307 327.598 761.621 327.657 761.914 327.776C762.207 327.895 762.473 328.072 762.697 328.296C762.92 328.519 763.097 328.786 763.216 329.079C763.335 329.372 763.395 329.685 763.391 330.002V388.095",
    fill: "none",
    stroke: "#6F6F6F",
    strokeWidth: 1.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M605.109 285.898H613.209C613.844 285.906 614.449 286.162 614.898 286.61C615.346 287.058 615.602 287.664 615.609 288.298V393.368",
    fill: "none",
    stroke: "#6F6F6F",
    strokeWidth: 1.5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 142.5H0V351.6H42.8V142.5Z",
    fill: "#dddddd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3 67.1953V214.695H108.3C117.912 214.691 127.285 217.699 135.1 223.295L247.2 303.495C239.4 312.195 226 319.495 203 321.495C178.4 323.595 164.5 333.195 156.7 343.895L156.6 343.995L116.3 314.195H42.3V351.495H0",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2969 67.1953V214.695H108.297C117.909 214.691 127.282 217.699 135.097 223.295L247.197 303.495C239.397 312.195 225.997 319.495 202.997 321.495C178.397 323.595 164.497 333.195 156.697 343.895L156.597 343.995L116.297 314.195H42.2969V351.495",
    fill: "#dddddd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2969 67.1953V214.695H108.297C117.909 214.691 127.282 217.699 135.097 223.295L247.197 303.495C239.397 312.195 225.997 319.495 202.997 321.495C178.397 323.595 164.497 333.195 156.697 343.895L156.597 343.995L116.297 314.195H42.2969V351.495",
    fill: "#dddddd",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M169.103 394.003C169.103 394.003 164.503 343.103 225.303 337.903C289.903 332.303 278.903 284.203 278.903 284.203",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M146.9 377.798C146.9 377.798 142.3 326.898 203.1 321.598C267.7 315.998 256.8 267.898 256.8 267.898",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M697.602 26.2033H745.599C745.915 26.1989 746.229 26.2643 746.522 26.3957C746.815 26.5272 747.081 26.7219 747.305 26.9686C747.529 27.2152 747.705 27.5087 747.824 27.8318C747.944 28.1549 748.003 28.501 747.999 28.8498V49.2497C747.991 49.9489 747.736 50.6171 747.287 51.1115C746.839 51.606 746.233 51.8876 745.599 51.8962H725C724.366 51.9047 723.76 52.1863 723.312 52.6808C722.863 53.1752 722.608 53.8434 722.6 54.5426V58.9534C722.608 59.6526 722.863 60.3208 723.312 60.8153C723.76 61.3097 724.366 61.5913 725 61.5999H745.599C746.233 61.6085 746.839 61.89 747.287 62.3845C747.736 62.879 747.991 63.5471 747.999 64.2464V169.003C747.991 169.702 747.736 170.37 747.287 170.864C746.839 171.359 746.233 171.64 745.599 171.649H722.4C721.766 171.658 721.16 171.939 720.712 172.434C720.263 172.928 720.008 173.596 720 174.295V189.733C720 191.167 718.9 193.262 717.6 193.262H712.701C712.067 193.27 711.461 193.552 711.012 194.046C710.564 194.541 710.309 195.209 710.301 195.908V235.054C710.309 235.753 710.564 236.421 711.012 236.916C711.461 237.41 712.067 237.692 712.701 237.7H755.398C756.033 237.709 756.638 237.991 757.087 238.485C757.535 238.98 757.791 239.648 757.798 240.347V279.382C757.791 280.082 757.535 280.75 757.087 281.244C756.638 281.739 756.033 282.02 755.398 282.029H712.601C711.967 282.037 711.361 282.319 710.912 282.814C710.464 283.308 710.209 283.976 710.201 284.675V285.227C710.209 285.926 710.464 286.594 710.912 287.089C711.361 287.583 711.967 287.865 712.601 287.873H719.8C720.434 287.882 721.04 288.163 721.489 288.658C721.937 289.152 722.192 289.82 722.2 290.52C722.192 291.219 721.937 291.887 721.489 292.382C721.04 292.876 720.434 293.158 719.8 293.166H712.501C711.867 293.175 711.261 293.456 710.812 293.951C710.364 294.445 710.109 295.113 710.101 295.813V299.01C710.109 299.71 710.364 300.378 710.812 300.872C711.261 301.367 711.867 301.648 712.501 301.657H724.6C725.234 301.665 725.84 301.947 726.288 302.442C726.737 302.936 726.992 303.604 727 304.303V358.777C726.992 359.476 726.737 360.144 726.288 360.638C725.84 361.133 725.234 361.414 724.6 361.423H719C718.366 361.432 717.76 361.713 717.312 362.208C716.864 362.702 716.608 363.37 716.601 364.07V386.424",
    fill: "none",
    stroke: "#EDEDED",
    strokeWidth: 1.5
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M778.503 223.203H756.203V302.203H778.503V223.203Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M800.902 223.203H778.602V302.203H800.902V223.203Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M783.297 236.695H796.197",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M783.297 241H796.197",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M783.297 245.398H796.197",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M783.297 249.703H796.197",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M778.602 262.805H801.002",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M823.3 223.203H801V302.203H823.3V223.203Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M805.703 236.695H818.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M805.703 241H818.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M805.703 245.398H818.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M805.703 249.703H818.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M801 262.805H823.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M845.597 223.203H823.297V302.203H845.597V223.203Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M828 236.695H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M828 241H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M828 245.398H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M828 249.703H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M823.297 262.805H845.697",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M868.003 223.203H845.703V302.203H868.003V223.203Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M850.398 236.695H863.298",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M850.398 241H863.298",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M850.398 245.398H863.298",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M850.398 249.703H863.298",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M783.297 275.695H796.197",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M783.297 280H796.197",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M783.297 284.398H796.197",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M783.297 288.695H796.197",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M761 236.695H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M761 241H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M761 245.398H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M761 249.703H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M756.203 262.805H778.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M761 275.695H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M761 280H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M761 284.398H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M761 288.695H773.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M805.703 275.695H818.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M805.703 280H818.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M805.703 284.398H818.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M805.703 288.695H818.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M828 275.695H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M828 280H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M828 284.398H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M828 288.695H840.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M850.398 275.695H863.298",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M850.398 280H863.298",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M850.398 284.398H863.298",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M850.398 288.695H863.298",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M845.703 262.805H868.003",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M890.3 223.203H868V302.203H890.3V223.203Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M872.703 236.695H885.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M872.703 241H885.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M872.703 245.398H885.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M872.703 249.703H885.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M872.703 275.695H885.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M872.703 280H885.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M872.703 284.398H885.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M872.703 288.695H885.603",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M868 262.805H890.3",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M511.803 231.805H513.403C514.942 231.805 516.417 232.416 517.505 233.504C518.592 234.591 519.203 236.067 519.203 237.605V237.605V285.205C519.203 285.947 518.908 286.66 518.383 287.185C517.858 287.71 517.146 288.005 516.403 288.005H508.903C508.161 288.005 507.448 287.71 506.923 287.185C506.398 286.66 506.103 285.947 506.103 285.205V237.605C506.085 236.846 506.218 236.092 506.497 235.386C506.775 234.681 507.193 234.038 507.725 233.497C508.256 232.956 508.891 232.528 509.592 232.237C510.293 231.946 511.045 231.799 511.803 231.805V231.805Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M547.002 235.195C547.974 235.193 548.938 235.382 549.837 235.753C550.736 236.124 551.552 236.669 552.24 237.357C552.928 238.045 553.473 238.861 553.844 239.76C554.215 240.659 554.404 241.623 554.402 242.595V242.595V256.995C554.404 257.968 554.215 258.931 553.844 259.83C553.473 260.729 552.928 261.546 552.24 262.234C551.552 262.921 550.736 263.466 549.837 263.837C548.938 264.208 547.974 264.398 547.002 264.395V264.395C546.029 264.398 545.066 264.208 544.167 263.837C543.268 263.466 542.451 262.921 541.763 262.234C541.076 261.546 540.53 260.729 540.16 259.83C539.789 258.931 539.599 257.968 539.602 256.995V242.695C539.594 240.721 540.368 238.824 541.754 237.418C543.141 236.013 545.027 235.214 547.002 235.195V235.195Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M542.797 247.102V258.802",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M545.602 247.805V259.505",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M548.5 247.805V259.505",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M551.297 247.102V258.802",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M566.697 235.195C567.669 235.193 568.633 235.382 569.532 235.753C570.431 236.124 571.248 236.669 571.935 237.357C572.623 238.045 573.168 238.861 573.539 239.76C573.91 240.659 574.1 241.623 574.097 242.595V256.995C574.1 257.968 573.91 258.931 573.539 259.83C573.168 260.729 572.623 261.546 571.935 262.234C571.248 262.921 570.431 263.466 569.532 263.837C568.633 264.208 567.669 264.398 566.697 264.395V264.395C565.724 264.398 564.761 264.208 563.862 263.837C562.963 263.466 562.146 262.921 561.458 262.234C560.771 261.546 560.226 260.729 559.855 259.83C559.484 258.931 559.294 257.968 559.297 256.995V256.995V242.695C559.289 240.721 560.063 238.824 561.449 237.418C562.836 236.013 564.723 235.214 566.697 235.195V235.195Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M562.5 247.102V258.802",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M565.297 247.805V259.505",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M568.102 247.805V259.505",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M571 247.102V258.802",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M626.098 258.898H520.398V290.598H626.098V258.898Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M533.898 216.203H520.398V239.103H533.898V216.203Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M520.402 230.797L512.602 283.497H520.402V230.797Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M512.597 222.299C513.231 222.306 513.837 222.562 514.286 223.01C514.734 223.459 514.989 224.065 514.997 224.699V229.399C514.989 230.033 514.734 230.639 514.286 231.087C513.837 231.536 513.231 231.791 512.597 231.799V231.799C511.963 231.791 511.357 231.536 510.909 231.087C510.46 230.639 510.205 230.033 510.197 229.399V229.399V224.699C510.184 224.38 510.238 224.062 510.354 223.765C510.47 223.469 510.646 223.199 510.872 222.973C511.097 222.748 511.367 222.572 511.664 222.456C511.961 222.339 512.279 222.286 512.597 222.299V222.299Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M527.102 264.5V285.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M600.9 249.102H599.5V258.902H600.9V249.102Z",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M600.497 249.798C602.816 249.798 604.697 247.918 604.697 245.598C604.697 243.279 602.816 241.398 600.497 241.398C598.177 241.398 596.297 243.279 596.297 245.598C596.297 247.918 598.177 249.798 600.497 249.798Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M599.203 246.402L600.503 245.602",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M530.2 239.303C530.261 240.103 530.013 240.895 529.506 241.517C529 242.138 528.275 242.542 527.48 242.645C526.684 242.747 525.88 242.541 525.233 242.068C524.585 241.595 524.144 240.892 524 240.103V239.203H530.2V239.303Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M527.102 242.797V249.397C527.114 250.914 527.715 252.367 528.779 253.449C529.842 254.531 531.285 255.158 532.802 255.197V255.197C534.113 255.177 535.38 254.72 536.402 253.897L539.502 251.397",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M590.8 244.695H588V252.095H590.8V244.695Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M586.597 241.399H589.397C589.701 241.393 590.002 241.449 590.284 241.563C590.565 241.676 590.821 241.846 591.036 242.06C591.25 242.275 591.42 242.531 591.533 242.812C591.647 243.094 591.703 243.395 591.697 243.699V243.699C591.703 244.002 591.647 244.304 591.533 244.585C591.42 244.867 591.25 245.123 591.036 245.337C590.821 245.552 590.565 245.721 590.284 245.835C590.002 245.948 589.701 246.004 589.397 245.999H586.597C586.294 246.004 585.992 245.948 585.711 245.835C585.429 245.721 585.173 245.552 584.959 245.337C584.744 245.123 584.575 244.867 584.461 244.585C584.348 244.304 584.292 244.002 584.297 243.699V243.699C584.292 243.395 584.348 243.094 584.461 242.812C584.575 242.531 584.744 242.275 584.959 242.06C585.173 241.846 585.429 241.676 585.711 241.563C585.992 241.449 586.294 241.393 586.597 241.399V241.399Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M621.302 253.602H613.602V258.702H621.302V253.602Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M617.4 255.402C620.935 255.402 623.8 252.536 623.8 249.002C623.8 245.467 620.935 242.602 617.4 242.602C613.865 242.602 611 245.467 611 249.002C611 252.536 613.865 255.402 617.4 255.402Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M527.598 290.695H520.398V295.195H527.598V290.695Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M626.098 290.695H618.898V295.195H626.098V290.695Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M543.898 281.102C547.212 281.102 549.898 278.415 549.898 275.102C549.898 271.788 547.212 269.102 543.898 269.102C540.585 269.102 537.898 271.788 537.898 275.102C537.898 278.415 540.585 281.102 543.898 281.102Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M565.898 281.102C569.212 281.102 571.898 278.415 571.898 275.102C571.898 271.788 569.212 269.102 565.898 269.102C562.585 269.102 559.898 271.788 559.898 275.102C559.898 278.415 562.585 281.102 565.898 281.102Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M587.797 281.102C591.111 281.102 593.797 278.415 593.797 275.102C593.797 271.788 591.111 269.102 587.797 269.102C584.483 269.102 581.797 271.788 581.797 275.102C581.797 278.415 584.483 281.102 587.797 281.102Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M609.797 281.102C613.111 281.102 615.797 278.415 615.797 275.102C615.797 271.788 613.111 269.102 609.797 269.102C606.483 269.102 603.797 271.788 603.797 275.102C603.797 278.415 606.483 281.102 609.797 281.102Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M583.402 243.695C582.129 243.695 580.908 244.201 580.007 245.101C579.107 246.001 578.602 247.222 578.602 248.495V248.495V258.295",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M607.9 253.305H582.5V258.805H607.9V253.305Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7969 314.305V313.305",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7969 311.198V303.898",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeDasharray: "2.08 2.08 2.08 2.08"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7969 302.895V216.695",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeDasharray: "2.08 2.08 2.08 2.08 2.08 2.08"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M42.7969 215.695V214.695",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M68.6 238.4V323.9H57.5V146H68.6V238.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4984 238.4V323.9H81.3984V146H92.4984V238.4Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8 142.398H0",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M505.8 351.602H361V436.602H505.8V351.602Z",
    fill: "#F6F6F6",
    stroke: "#202020"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M435.603 447.997C464.819 447.997 488.503 424.223 488.503 394.897C488.503 365.571 464.819 341.797 435.603 341.797C406.387 341.797 382.703 365.571 382.703 394.897C382.703 424.223 406.387 447.997 435.603 447.997Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M401.203 360.297L471.703 430.897",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.02 4.05"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M401.203 429.498L471.703 358.898",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.02 4.05"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M435.598 412.595C445.374 412.595 453.298 404.671 453.298 394.895C453.298 385.12 445.374 377.195 435.598 377.195C425.823 377.195 417.898 385.12 417.898 394.895C417.898 404.671 425.823 412.595 435.598 412.595Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M400.102 532.002H413.502V420.602C413.066 422.061 412.167 423.339 410.94 424.242C409.713 425.144 408.225 425.621 406.702 425.602C405.198 425.639 403.726 425.165 402.527 424.256C401.328 423.348 400.473 422.059 400.102 420.602V532.002Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M393.102 533.3C393.102 529.64 394.555 526.13 397.143 523.542C399.731 520.954 403.242 519.5 406.902 519.5C410.562 519.5 414.072 520.954 416.66 523.542C419.248 526.13 420.702 529.64 420.702 533.3H393.102Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M409.998 424.6L442.698 402.2L428.598 387L401.898 413.9L409.998 424.6Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M435.603 404.902C441.347 404.902 446.003 400.245 446.003 394.502C446.003 388.758 441.347 384.102 435.603 384.102C429.859 384.102 425.203 388.758 425.203 394.502C425.203 400.245 429.859 404.902 435.603 404.902Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M406.9 425.605C410.711 425.605 413.8 422.515 413.8 418.705C413.8 414.894 410.711 411.805 406.9 411.805C403.089 411.805 400 414.894 400 418.705C400 422.515 403.089 425.605 406.9 425.605Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M502.898 352V352.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M502.898 358V433.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.1 5.91"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M502.898 436V436.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M522.797 352V352.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M522.797 358V433.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.1 5.91"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M522.797 436V436.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M517.403 347.398H508.203V440.798H517.403V347.398Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M508.298 350H503.398V438.1H508.298V350Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M522.3 350H517.5V438.1H522.3V350Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M348.797 352V352.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M348.797 358V433.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.1 5.91"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M348.797 436V436.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M368.602 352V352.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M368.602 358V433.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0.1 5.91"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M368.602 436V436.1",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M363.302 347.398H354.102V440.798H363.302V347.398Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M354.103 350H349.203V438.1H354.103V350Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M368.197 350H363.297V438.1H368.197V350Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M458.597 228.5H455.797V253.5H458.597V228.5Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M457.199 225.196H466.899C467.202 225.19 467.504 225.246 467.785 225.36C468.067 225.473 468.323 225.643 468.537 225.857C468.752 226.072 468.921 226.328 469.035 226.609C469.148 226.891 469.204 227.192 469.199 227.496V227.496C469.204 227.799 469.148 228.101 469.035 228.382C468.921 228.664 468.752 228.919 468.537 229.134C468.323 229.349 468.067 229.518 467.785 229.632C467.504 229.745 467.202 229.801 466.899 229.796H457.199C456.895 229.801 456.594 229.745 456.312 229.632C456.031 229.518 455.775 229.349 455.56 229.134C455.346 228.919 455.176 228.664 455.063 228.382C454.949 228.101 454.893 227.799 454.899 227.496C454.893 227.192 454.949 226.891 455.063 226.609C455.176 226.328 455.346 226.072 455.56 225.857C455.775 225.643 456.031 225.473 456.312 225.36C456.594 225.246 456.895 225.19 457.199 225.196Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M384.703 251.797H453.203C457.843 251.802 462.291 253.648 465.572 256.928C468.852 260.209 470.698 264.657 470.703 269.297V273.797C470.698 278.437 468.852 282.885 465.572 286.165C462.291 289.446 457.843 291.292 453.203 291.297H384.703C380.063 291.292 375.615 289.446 372.335 286.165C369.054 282.885 367.208 278.437 367.203 273.797V269.297C367.208 264.657 369.054 260.209 372.335 256.928C375.615 253.648 380.063 251.802 384.703 251.797V251.797Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M405.402 247.605H388.102L388.902 243.305H404.502L405.402 247.605Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M429.402 248.102H386.602V251.802H429.402V248.102Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M433.996 251.7C433.92 251.283 433.929 250.853 434.024 250.439C434.119 250.025 434.297 249.635 434.548 249.292C434.798 248.949 435.116 248.66 435.482 248.444C435.848 248.227 436.253 248.088 436.675 248.034C437.096 247.979 437.524 248.011 437.933 248.128C438.341 248.244 438.722 248.442 439.051 248.711C439.381 248.979 439.652 249.311 439.849 249.688C440.046 250.064 440.164 250.477 440.196 250.9V250.9V251.7H433.996Z",
    fill: "#6F6F6F",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M437.102 245.505H441.102C441.431 245.507 441.757 245.445 442.061 245.32C442.366 245.195 442.643 245.011 442.875 244.778C443.108 244.546 443.292 244.269 443.417 243.965C443.541 243.66 443.604 243.334 443.602 243.005V243.005V239.805",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M390.7 291.297H383.5V295.797H390.7V291.297Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M454.497 291.297H447.297V295.797H454.497V291.297Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M447.697 241.602H446.297V251.402H447.697V241.602Z",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M447.302 242.298C449.621 242.298 451.502 240.418 451.502 238.098C451.502 235.779 449.621 233.898 447.302 233.898C444.982 233.898 443.102 235.779 443.102 238.098C443.102 240.418 444.982 242.298 447.302 242.298Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M446 238.902L447.3 238.102",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M375.797 235.502C375.794 234.529 375.984 233.566 376.355 232.667C376.726 231.768 377.271 230.951 377.958 230.263C378.646 229.575 379.463 229.03 380.362 228.659C381.261 228.289 382.224 228.099 383.197 228.102H407.297C408.269 228.099 409.233 228.289 410.132 228.659C411.031 229.03 411.848 229.575 412.535 230.263C413.223 230.951 413.768 231.768 414.139 232.667C414.51 233.566 414.7 234.529 414.697 235.502V235.502C414.7 236.474 414.51 237.438 414.139 238.337C413.768 239.236 413.223 240.052 412.535 240.74C411.848 241.428 411.031 241.973 410.132 242.344C409.233 242.715 408.269 242.904 407.297 242.902H383.197C381.238 242.888 379.364 242.105 377.979 240.72C376.594 239.335 375.81 237.46 375.797 235.502V235.502Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M386.602 239.703H409.102",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5 236.898H410.4",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M387.5 234.102H410.4",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M386.602 231.203H409.102",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M377.503 225.898H380.603C381.611 225.898 382.577 226.299 383.29 227.011C384.003 227.724 384.403 228.691 384.403 229.698V241.398C384.403 242.406 384.003 243.373 383.29 244.085C382.577 244.798 381.611 245.198 380.603 245.198H377.503C376.495 245.198 375.529 244.798 374.816 244.085C374.103 243.373 373.703 242.406 373.703 241.398V229.698C373.703 228.691 374.103 227.724 374.816 227.011C375.529 226.299 376.495 225.898 377.503 225.898V225.898Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M407.5 206.797H427.6C427.824 206.796 428.045 206.839 428.252 206.924C428.459 207.009 428.647 207.134 428.805 207.292C428.963 207.45 429.088 207.638 429.173 207.845C429.258 208.052 429.301 208.273 429.3 208.497C429.301 208.721 429.258 208.942 429.173 209.149C429.088 209.356 428.963 209.544 428.805 209.702C428.647 209.86 428.459 209.985 428.252 210.07C428.045 210.155 427.824 210.198 427.6 210.197H407.5V206.797V206.797Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M425.398 226.295H411.398L410.398 213.695H426.398L425.398 226.295Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M411.398 206.203H425.398L426.398 213.303H410.398L411.398 206.203Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M405.902 203.899C406.205 203.893 406.507 203.949 406.788 204.063C407.07 204.176 407.326 204.346 407.54 204.56C407.755 204.775 407.924 205.031 408.038 205.312C408.152 205.594 408.207 205.895 408.202 206.199V211.399C408.207 211.702 408.152 212.004 408.038 212.285C407.924 212.567 407.755 212.823 407.54 213.037C407.326 213.252 407.07 213.421 406.788 213.535C406.507 213.648 406.205 213.704 405.902 213.699V213.699C405.598 213.704 405.297 213.648 405.015 213.535C404.734 213.421 404.478 213.252 404.263 213.037C404.049 212.823 403.88 212.567 403.766 212.285C403.652 212.004 403.597 211.702 403.602 211.399V206.199C403.61 205.591 403.855 205.011 404.284 204.581C404.714 204.151 405.294 203.907 405.902 203.899V203.899Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M428.602 248.105H408.102L409.102 225.805H427.602L428.602 248.105Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M429.297 208.5H434.597C434.926 208.497 435.252 208.56 435.557 208.685C435.861 208.81 436.138 208.994 436.371 209.226C436.603 209.459 436.787 209.736 436.912 210.04C437.037 210.345 437.1 210.671 437.097 211V251.8",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M484.198 160.202H457.398L458.698 153.602H482.898L484.198 160.202Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M449.899 129.899H487.299C490.349 129.899 493.274 131.11 495.43 133.267C497.587 135.424 498.799 138.349 498.799 141.399V141.399C498.799 144.449 497.587 147.374 495.43 149.53C493.274 151.687 490.349 152.899 487.299 152.899H449.899C446.849 152.899 443.924 151.687 441.767 149.53C439.61 147.374 438.399 144.449 438.399 141.399C438.391 139.886 438.683 138.387 439.258 136.988C439.833 135.59 440.68 134.319 441.749 133.249C442.819 132.18 444.09 131.333 445.488 130.758C446.887 130.183 448.386 129.891 449.899 129.899V129.899Z",
    fill: "#DDDDDD",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M455 148H489.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M456.398 143.602H491.898",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M456.398 139.203H491.898",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M455 134.805H489.9",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M441.002 126.5H445.902C446.678 126.494 447.449 126.642 448.167 126.936C448.886 127.23 449.539 127.664 450.089 128.213C450.638 128.763 451.072 129.416 451.366 130.135C451.66 130.853 451.808 131.624 451.802 132.4V150.5C451.808 151.277 451.66 152.047 451.366 152.766C451.072 153.485 450.638 154.138 450.089 154.687C449.539 155.236 448.886 155.671 448.167 155.965C447.449 156.259 446.678 156.407 445.902 156.4H441.002C440.225 156.407 439.455 156.259 438.736 155.965C438.017 155.671 437.364 155.236 436.815 154.687C436.266 154.138 435.831 153.485 435.537 152.766C435.243 152.047 435.095 151.277 435.102 150.5V132.4C435.095 131.624 435.243 130.853 435.537 130.135C435.831 129.416 436.266 128.763 436.815 128.213C437.364 127.664 438.017 127.23 438.736 126.936C439.455 126.642 440.225 126.494 441.002 126.5V126.5Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M352 134H369.7C370.334 134.008 370.94 134.263 371.388 134.712C371.837 135.16 372.092 135.766 372.1 136.4V136.4V138.9C372.092 139.534 371.837 140.14 371.388 140.588C370.94 141.037 370.334 141.292 369.7 141.3H363.9C363.584 141.296 363.27 141.355 362.977 141.474C362.684 141.594 362.418 141.77 362.194 141.994C361.97 142.218 361.794 142.484 361.674 142.777C361.555 143.07 361.496 143.384 361.5 143.7V143.7V145.6C361.508 146.234 361.763 146.84 362.212 147.288C362.66 147.737 363.266 147.992 363.9 148H369.7C370.334 148.008 370.94 148.263 371.388 148.712C371.837 149.16 372.092 149.766 372.1 150.4V150.4V152.9C372.092 153.534 371.837 154.14 371.388 154.588C370.94 155.037 370.334 155.292 369.7 155.3H352.5",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M366.603 162.503C376.489 162.503 384.503 154.489 384.503 144.603C384.503 134.717 376.489 126.703 366.603 126.703C356.717 126.703 348.703 134.717 348.703 144.603C348.703 154.489 356.717 162.503 366.603 162.503Z",
    fill: "none",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M666.786 338.094H659.586V358.194H666.786V338.094Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M715.739 338.094H708.539V358.194H715.739V338.094Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M704.459 338.094H670.859V363.194H704.459V338.094Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M699.461 68.2266H675.898V338.093H699.461V68.2266Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M714.444 42.4141H660.844V68.2141H714.444V42.4141Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M656.786 45.0781H649.586V65.1781H656.786V45.0781Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M725.739 45.0781H718.539V65.1781H725.739V45.0781Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M706.603 35.9141H668.703V42.4141H706.603V35.9141Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M699.863 185.141H673.242V204.866H699.863V185.141Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M713.13 182.625H662.227V185.143H713.13V182.625Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M705.033 204.867H670.258V209.664H705.033V204.867Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M820.186 105.594H555.086V175.994H820.186V105.594Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M565.286 112.992H560.586V168.592H565.286V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M576.591 112.992H569.391V168.592H576.591V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M590.589 112.992H580.789V168.592H590.589V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M607.089 112.992H594.789V168.592H607.089V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M626.089 112.992H611.289V168.592H626.089V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M647.689 112.992H630.289V168.592H647.689V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M671.791 112.992H651.891V168.592H671.791V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M698.392 112.992H675.992V168.592H698.392V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M814.091 112.992H809.391V168.592H814.091V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M805.192 112.992H797.992V168.592H805.192V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M793.792 112.992H783.992V168.592H793.792V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M779.792 112.992H767.492V168.592H779.792V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M763.292 112.992H748.492V168.592H763.292V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M744.392 112.992H726.992V168.592H744.392V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M722.791 112.992H702.891V168.592H722.791V112.992Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M699.436 22.2188H675.836V36.0188H699.436V22.2188Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M690.473 9.61719H684.773V22.2172H690.473V9.61719Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M651.372 252.836H644.172V272.936H651.372V252.836Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M651.719 278.792L651.719 285.992L671.819 285.992L671.819 278.792L651.719 278.792Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M703.516 278.792L703.516 285.992L723.616 285.992L723.616 278.792L703.516 278.792Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M731.091 252.836H723.891V272.936H731.091V252.836Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M719.847 252.836H655.453V274.6H719.847V252.836Z",
    fill: "white",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M592.477 83.1544L592.477 105.398L600.751 105.398L600.751 83.1544L592.477 83.1544Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.49892
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M592.477 68.227L592.477 83.1562L675.877 83.1562L675.877 68.227L592.477 68.227Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.49892
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M782.844 83.1544L782.844 105.398L774.57 105.398L774.57 83.1544L782.844 83.1544Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.49892
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M782.844 68.227L782.844 83.1562L699.444 83.1562L699.444 68.227L782.844 68.227Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.49892
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M699.761 90.9531H675.299C674.305 90.9531 673.5 91.7584 673.5 92.7518V103.124H701.56V92.7518C701.56 91.7584 700.755 90.9531 699.761 90.9531Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.49892
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M701.797 103.124L701.797 101.445L673.737 101.445L673.737 103.124L701.797 103.124Z",
    fill: "#202020",
    stroke: "#202020",
    strokeWidth: 0.683284
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M710.429 103.125H664.922V105.583H710.429V103.125Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.49892
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M727.337 369.992H652.031H573.008L610.457 409.378C612.615 409.282 618.995 409.702 625.446 412.064C629.427 413.521 632.773 415.469 635.381 417.862C638.601 420.812 640.693 424.427 641.604 428.612L640.885 428.768L641.616 428.864L630.141 517.552H744.88L733.405 428.864L734.376 428.738L733.422 428.468C734.586 424.337 736.984 420.758 740.551 417.838C743.381 415.523 746.943 413.623 751.146 412.178C757.537 409.983 763.353 409.54 764.66 409.468L804.531 369.992H727.337Z",
    fill: "#EDEDED"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M726.89 368.82L650.678 368.85H566.445L609.59 410.592L609.836 410.856L610.196 410.82C611.736 410.664 618.35 411 624.903 413.398C628.704 414.789 631.882 416.642 634.352 418.902C637.308 421.612 639.245 424.928 640.102 428.759L628.536 518.149L628.524 518.239L628.428 518.982H628.524C628.548 529.301 630.245 539.482 633.573 549.255C636.984 559.261 642.009 568.567 648.508 576.901L649.671 575.995C643.274 567.787 638.327 558.632 634.97 548.775C631.69 539.152 630.023 529.133 629.999 518.976H744.996C745.542 521.129 746.837 522.987 748.678 524.259C750.231 525.332 752.029 525.883 753.876 525.883C755.723 525.883 754.979 525.835 755.531 525.734L755.267 524.283C753.247 524.648 751.202 524.211 749.511 523.041C748.066 522.04 747.023 520.613 746.519 518.952L734.84 428.693C735.931 424.91 738.143 421.63 741.435 418.938C744.121 416.738 747.527 414.921 751.556 413.53C758.469 411.15 764.884 410.874 764.95 410.874L765.214 410.862L802.129 368.82H726.338H726.89ZM764.626 409.423C763.319 409.495 757.503 409.939 751.112 412.133C746.909 413.572 743.348 415.479 740.518 417.793C736.95 420.713 734.552 424.286 733.389 428.423L733.371 428.813L744.847 517.501H630.101L641.577 428.813L641.565 428.561C640.654 424.376 638.561 420.761 635.341 417.811C632.733 415.419 629.388 413.47 625.407 412.013C618.955 409.657 612.582 409.231 610.417 409.327L569.857 370.325H650.678L727.01 370.295H798.226L764.62 409.429L764.626 409.423Z",
    fill: "#202020"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M699.461 363.219H675.898V394.276H699.461V363.219Z",
    fill: "#EDEDED",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M726.088 386.906H648.484V397.511H726.088V386.906Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.75699
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M649.858 404.044C656.044 404.044 661.059 399.013 661.059 392.807C661.059 386.601 656.044 381.57 649.858 381.57C643.671 381.57 638.656 386.601 638.656 392.807C638.656 399.013 643.671 404.044 649.858 404.044Z",
    fill: "#F6F6F6",
    stroke: "#202020",
    strokeWidth: 1.75699
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M725.42 404.044C731.607 404.044 736.622 399.013 736.622 392.807C736.622 386.601 731.607 381.57 725.42 381.57C719.234 381.57 714.219 386.601 714.219 392.807C714.219 399.013 719.234 404.044 725.42 404.044Z",
    fill: "#F6F6F6",
    stroke: "#202020",
    strokeWidth: 1.75699
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M618.724 407.405C625.264 407.405 630.566 401.379 630.566 393.945C630.566 386.511 625.264 380.484 618.724 380.484C612.184 380.484 606.883 386.511 606.883 393.945C606.883 401.379 612.184 407.405 618.724 407.405Z",
    fill: "#F6F6F6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M617.437 376.648H559.039V411.244H617.437V376.648Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M756.573 407.405C750.033 407.405 744.731 401.379 744.731 393.945C744.731 386.511 750.033 380.484 756.573 380.484C763.112 380.484 768.414 386.511 768.414 393.945C768.414 401.379 763.112 407.405 756.573 407.405Z",
    fill: "#F6F6F6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M757.86 376.648H816.258V411.244H757.86V376.648Z",
    fill: "#9C9C9C",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M560.197 420.477C574.777 420.477 586.597 408.612 586.597 393.977C586.597 379.341 574.777 367.477 560.197 367.477C545.617 367.477 533.797 379.341 533.797 393.977C533.797 408.612 545.617 420.477 560.197 420.477Z",
    fill: "#F6F6F6",
    stroke: "#202020",
    strokeWidth: 1.5
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M825.753 436.602C849.115 436.602 868.053 417.574 868.053 394.102C868.053 370.629 849.115 351.602 825.753 351.602C802.391 351.602 783.453 370.629 783.453 394.102C783.453 417.574 802.391 436.602 825.753 436.602Z",
    fill: "#F6F6F6",
    stroke: "#202020",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalfunctionsPeltonmiv);
export default __webpack_public_path__ + "static/media/malfunctions_pelton+miv.c4bc33ad68c0a52c82c25c21ae6f20e7.svg";
export { ForwardRef as ReactComponent };